import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  cursor: "pointer",
  width: 40,
  height: 40,
  borderRadius: "full",
  outline: "none",
}
